import Swiper, {Controller, Navigation} from "swiper";

const Slider = (element: HTMLElement) =>
	new Swiper(element, {
		modules: [Navigation, Controller],
		slidesPerView: "auto",
		spaceBetween: 16,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});

export default () => {
	const sliders: HTMLElement[] = Array.from(
		document.querySelectorAll(".block.slider-image .slider")
	);

	if (!sliders) return;

	sliders.map((element: HTMLElement) => Slider(element));
};
